document.addEventListener('DOMContentLoaded', function() {
    let productActionsSummery = document.querySelector('.product-actions-summery');
    let header = document.querySelector('.shopify-section--header');
    let isSticky = false;

    if (!productActionsSummery || !header) return;

    let headerHeight = header.offsetHeight;
    let initialPosition = productActionsSummery.offsetTop - headerHeight;

    let checkStickyPosition = function() {
        let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        let triggerPosition = scrollPosition + productActionsSummery.offsetHeight;

        if (triggerPosition > initialPosition && !isSticky) {
            productActionsSummery.classList.add('sticky');
            isSticky = true;
        } else if (triggerPosition <= initialPosition && isSticky) {
            productActionsSummery.classList.remove('sticky');
            isSticky = false;
        }
    };

    window.addEventListener('scroll', checkStickyPosition);

    // Gallery sticky is handled purely by CSS (no JS toggling)
    // Product-content scrolls over the gallery via z-index
});